import newOpenMenu from '@/services/menulog';
import { Effect } from '@/typings/connect.d';

export interface menuLogModel {
  namespace: string;
  state: any;
  effects: {
    newOpenMenu: Effect;
  };
}

const menuLogModel: menuLogModel = {
  namespace: 'menuLog',

  state: null,

  effects: {
    *newOpenMenu({ payload }, { call }) {
      yield call(newOpenMenu, payload);
    },
  },
};

export default menuLogModel;
